import React from 'react';

const arrowRightCircle = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37.5"
        height="37.5"
        viewBox="0 0 37.5 37.5"
        style={{ fill: 'none', stroke: '#fff', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.5px' }}
      >
        <g
          id="Icon_feather-arrow-right-circle"
          data-name="Icon feather-arrow-right-circle"
          transform="translate(-2.25 -2.25)"
        >
          <path id="Path_3396" d="M39 21A18 18 0 1 1 21 3a18 18 0 0 1 18 18z" className="cls-1" data-name="Path 3396" />
          <path
            id="Path_3397"
            d="M18 26.4l7.2-7.2L18 12"
            className="cls-1"
            data-name="Path 3397"
            transform="translate(3 1.8)"
          />
          <path id="Path_3398" d="M12 18h14.4" className="cls-1" data-name="Path 3398" transform="translate(1.8 3)" />
        </g>
      </svg>
    </>
  );
};

export default arrowRightCircle;
